import React from 'react';
import { useI18n } from '@monorepo/i18n';

type Props = {
  status: string;
};

const UserStatus: Component<Props> = ({ status }) => {
  const { t } = useI18n();

  return <>{t(`user.status.${status}`)}</>;
};

export default UserStatus;
